import {createContext} from 'react'
import type {SubscriptionTier} from '@package/shared'

export type SubscriptionContextValue = {
  activeSubscriptionTier: SubscriptionTier
  loading: boolean
}

export const SubscriptionContext = createContext<SubscriptionContextValue>({} as SubscriptionContextValue)
